let googleMapsPromise = null

export function useGoogleMaps(apiKey) {
  if (typeof window === 'undefined') return Promise.reject('SSR not supported')

  // If Google Maps is already loaded, return it immediately
  if (window.google && window.google.maps) {
    return Promise.resolve(window.google.maps)
  }

  // If we're already loading, return the existing promise
  if (googleMapsPromise) return googleMapsPromise

  googleMapsPromise = new Promise((resolve, reject) => {
    // Create a unique callback name
    const callbackName = 'googleMapsCallback_' + Date.now()
    
    // Set up the global callback
    window[callbackName] = () => {
      // Clean up the callback
      delete window[callbackName]
      resolve(window.google.maps)
    }

    const script = document.createElement('script')
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places&callback=${callbackName}`
    script.async = true
    script.defer = true
    script.onerror = (err) => {
      delete window[callbackName]
      reject(err)
    }
    document.head.appendChild(script)
  })

  return googleMapsPromise
}